import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import CredentialsPage from './pages/CredentialsPage';
import HomePage from './pages/HomePage';
import CountryPage from './pages/CountryPage';
import ServicePage from './pages/ServicePage';
import TopicPage from './pages/TopicPage';
import PortalPage from './pages/PortalPage';
import ShipmentDetailPage from './pages/ShipmentDetailPage';
import AdminPage from './pages/AdminPage';
import ShopPage from './pages/ShopPage';
import { countrySlugs } from './data/countryPages';
import { serviceSlugs } from './data/servicePages';
import { topicSlugs } from './data/topicPages';
import './styles/App.css';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/credentials" element={<CredentialsPage />} />
                <Route path="/portal" element={<PortalPage />} />
                <Route path="/portal/shipments/:id" element={<ShipmentDetailPage />} />
                <Route path="/admin" element={<AdminPage />} />
                {topicSlugs.map((slug) => (
                  <Route key={slug} path={`/${slug}`} element={<TopicPage slug={slug} />} />
                ))}
                {countrySlugs.map((slug) => (
                  <Route key={slug} path={`/${slug}`} element={<CountryPage slug={slug} />} />
                ))}
                {serviceSlugs.map((slug) => (
                  <Route
                    key={slug}
                    path={`/services/${slug}`}
                    element={<ServicePage slug={slug} />}
                  />
                ))}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
};

export default App;
